<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8 2C9.65685 2 11 3.34315 11 5V19C11 20.6569 9.65685 22 8 22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2H8ZM19 2C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H16C14.3431 22 13 20.6569 13 19V5C13 3.34315 14.3431 2 16 2H19ZM8 4H5C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H8C8.55228 20 9 19.5523 9 19V5C9 4.44772 8.55228 4 8 4ZM19 4H16C15.4477 4 15 4.44772 15 5V19C15 19.5523 15.4477 20 16 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4Z"
    fill="currentColor"
  />
</svg>
